import { MenuRow } from './MenuRow';
import { MenuSurface } from './MenuSurface';
import type { AddItem, HeaderTheme } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface AddMenuProps {
  /** Picking a row CREATES that item and selects it — it does not open a placement mode. */
  onAdd?: (item: AddItem) => void;
  theme?: HeaderTheme;
  className?: string;
}

/** 332px wide, anchored right edge to the avatar slot's right edge. */
export const ADD_MENU_WIDTH = 332;

/**
 * The four things you can add directly. No shortcut hints: ⌘1..⌘4 belong to the browser's tab
 * switching, so nothing in the app binds them and no row may advertise them.
 */
const ROWS: Array<{ id: AddItem; icon: string; label: string }> = [
  { id: 'artifact', icon: 'slideshow-view', label: 'Artifact' },
  { id: 'image', icon: 'image', label: 'Image' },
  { id: 'document', icon: 'file-text', label: 'Document' },
  { id: 'website', icon: 'global', label: 'Website' },
];

/** The add menu, off the `+` slot. */
export function AddMenu({ onAdd, theme: themeProp, className }: AddMenuProps) {
  const theme = useV15Theme(themeProp);
  return (
    <MenuSurface width={ADD_MENU_WIDTH} theme={theme} label="Add" className={className}>
      {ROWS.map((row) => (
        <MenuRow
          key={row.id}
          icon={row.icon}
          label={row.label}
          theme={theme}
          onClick={() => onAdd?.(row.id)}
        />
      ))}
    </MenuSurface>
  );
}
